import { useCallback, useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { LocalStorageKeys } from '../enums';
import { LocalStorageService } from '../services';
import type { TExpertData } from '../types';
import { activeRequestsAtom } from '../../atoms';
import { fullDataAtom } from '../../atoms/fullDataAtom';

export function useGetExpertData() {
  const [expertInfo, setExpertInfo] = useState<TExpertData | null>(null);
  const [expertAvatar, setExpertAvatar] = useState<string | null>(null);
  const fullExpertData = useRecoilValue(fullDataAtom);

  const setActiveRequests = useSetRecoilState(activeRequestsAtom);

  const getFullDataFromStorage = useCallback(() => {
    setActiveRequests(prev => prev + 1);
    if (!fullExpertData) {
      console.log('need to handle case when full data is null');
      setActiveRequests(prev => prev - 1);
      return;
    }

    // Защита: expertProfile или zoneId внутри него может отсутствовать
    // (например, у эксперта с ещё не завершённой настройкой профиля).
    const zoneId = fullExpertData.expertProfile?.zoneId;
    if (zoneId) {
      LocalStorageService.setItem(LocalStorageKeys.TimeZone, zoneId);
    }

    setExpertInfo(fullExpertData.expertProfile ?? null);
    setExpertAvatar(fullExpertData.imageBase64 ?? null);
    setActiveRequests(prev => prev - 1);
  }, [fullExpertData, setActiveRequests]);

  useEffect(() => {
    getFullDataFromStorage();
    // Перезапускаем при каждом обновлении fullExpertData — компонент
    // страницы эксперта НЕ размонтируется при переходе /expert/1 -> /expert/2
    // (тот же роут, меняется только :id), поэтому эффект с []
    // срабатывал бы только один раз и "замораживал" данные первого эксперта.
  }, [fullExpertData, getFullDataFromStorage]);

  return { expertInfo, expertAvatar };
}